export const PURGE_AUTH = "logOut";
export const SET_AUTH = "setAuth";
export const SET_ERROR = "setError";
export const SET_CURRENT_USER = "setCurrentUser";

export const SET_SNACKBAR = "setSnackbar";
export const SET_CREATE_BUTTON = "setCreateButton";
export const SET_REFRESH_BUTTON = "setRefreshButton";
export const SET_VALIDATION_ERRORS = "setValidationErrors";
export const SET_AUTO_REFRESH_TIME = "setAutoRefreshTime";
export const SET_DICTIONARY = "setDictionary";

export const FETCH_USER_START = "setUserLoading";
export const SET_USERS = "setUsers";
export const SET_USER = "setUser";

export const FETCH_VEHICLE_START = "setVehicleLoading";
export const SET_VEHICLES = "setVehicles";
export const SET_VEHICLE = "setVehicle";

export const FETCH_FAULT_MESSAGE_START = "setFaultMessageLoading";
export const SET_FAULT_MESSAGES = "setFaultMessages";
export const SET_FAULT_MESSAGE = "setFaultMessage";

export const FETCH_FLEET_START = "setFleetLoading";
export const SET_FLEETS = "setFleets";
export const SET_FLEET = "setFleet";

export const FETCH_ISSUE_START = "setIssueLoading";
export const SET_ISSUES = "setIssues";
export const SET_ISSUE = "setIssue";
export const SET_ISSUE_STATUS_HISTORY = "setIssueStatusHistory";

export const FETCH_COMPONENT_START = "setComponentLoading";
export const SET_COMPONENTS = "setComponents";
export const SET_COMPONENT = "setComponent";

export const FETCH_SERVICE_REPORT_START = "setServiceReportLoading";
export const SET_SERVICE_REPORTS = "setServiceReports";
export const SET_SERVICE_REPORT = "setServiceReport";
export const SET_SERVICE_REPORTS_FOR_ISSUE = "setServiceReportsForIssue";

export const FETCH_REVIEW_REPORT_START = "setReviewReportLoading";
export const SET_REVIEW_REPORTS = "setReviewReports";
export const SET_REVIEW_REPORT = "setReviewReport";

export const FETCH_REPORT_START = "setReviewReportLoading";
export const SET_REPORT = "setReport";

export const FETCH_DASHBOARD_START = "setDashboardLoading";
export const FETCH_DASHBOARD_CHART_VEHICLES_DISTANCE_START =
  "setDashboardChartVehiclesDistanceLoading";
export const FETCH_DASHBOARD_CHART_ISSUES_STATUS_START =
  "setDashboardChartIssuesStatusLoading";
export const SET_DASHBOARD_STATISTICS = "setDashboardStatistics";
export const SET_CHART_VEHICLES_DISTANCE = "setDashboardChartVehiclesDistance";
export const SET_CHART_ISSUES_STATUS = "setDashboardChartIssuesStatus";

export const FETCH_COEFFICIENT_READINESS_START =
  "setCoefficientReadinessLoading";
export const SET_COEFFICIENT_READINESS_MONTHLY =
  "setCoefficientReadinessMonthly";
export const SET_COEFFICIENT_READINESS_YEARLY = "setCoefficientReadinessYearly";

export const FETCH_COEFFICIENT_RELIABILITY_START =
  "setCoefficientReliabilityLoading";
export const SET_COEFFICIENT_RELIABILITY = "setCoefficientReliability";
export const SET_COEFFICIENT_RELIABILITY_QUARTERLY =
  "setCoefficientReliabilityQuarterly";

export const FETCH_SPARE_PART_TYPE_START = "setSparePartTypeLoading";
export const SET_SPARE_PART_TYPES = "setSparePartTypes";
export const SET_SPARE_PART_TYPE = "setSparePartType";

export const FETCH_SPARE_PART_START = "setSparePartLoading";
export const SET_SPARE_PARTS = "setSpareParts";
export const SET_SPARE_PART = "setSparePart";

export const FETCH_VEHICLE_SPARE_PARTS_START = "setVehicleSparePartsLoading";
export const SET_VEHICLE_SPARE_PARTS = "setVehicleSpareParts";
export const FETCH_VEHICLE_SPARE_PART_HISTORY_START =
  "setVehicleSparePartsHistoryLoading";
export const SET_VEHICLE_SPARE_PART_HISTORY = "setVehicleSparePartHistory";
